import axiosApi from "../axiosInstance";

const getOwnerShipList = async () => {
    try {
        const response = await axiosApi.get(`/OwnerShipType/getOwnerShipList`);
        return response?.data;

    } catch (error) {
        console.log("Error getOwnerShipTypeList===>:", error);
         return error?.response?.data;
    }
};


const addOwnerShip = async (body) => {
    try {
        const response = await axiosApi.post(`OwnerShipType/CreateOwnerShipType`, body);
        return response?.data;
    } catch (error) {
        console.log("Error OwnerShipType ===>", error);
         return error?.response?.data;
    }
};

export const OwnerShipService = {
    getOwnerShipList,
    addOwnerShip
}